import { httpGetFile, httpGet_New, httpDelete_New, httpPost_New, httpPut_New, httpPatch_New } from './api.service';
import { GetReaderRequest, GetNearReaderRequest, LockLocationRequest, EditReportIntervalRequest } from '../requestModels/getReaderRequest';
import { LabelRequest } from '../requestModels/labelRequest';
import { PaginatedResult } from '../types/PaginatedResult';
import { ReaderLog } from '../types/ReaderLog';
import { Reader } from '../types/Reader';

export const getReaders = async (request?: GetReaderRequest) => {
  return await httpGet_New<PaginatedResult<Reader>>(`api/reader`, request);
};

export const exportReaders = async (request: GetReaderRequest): Promise<void> => {
  return await httpGetFile(`api/reader/export`, request);
};

export const getReaderByImei = async (imei: string): Promise<Reader> => {
  return await httpGet_New<Reader>(`api/reader/imei/${imei}`);
};

export const getReaderById = async (id: string): Promise<Reader> => {
  return await httpGet_New<Reader>('api/reader', { filters: [{ id: id }] });
};

export const getNearReaders = async (request: GetNearReaderRequest) => {
  const { skip, take, lat, lng, distanceInMeters } = request;
  return await httpGet_New<PaginatedResult<Reader>>(`api/reader/near/${lat}/${lng}/${distanceInMeters}`, {
    skip,
    take,
    filters: request.filters,
  });
};

export const updateLockedLocation = async (request: LockLocationRequest): Promise<void> => {
  await httpPatch_New(`api/reader/${request.imei}/lockedlocation`, request);
};

export const updateReportInterval = async (request: EditReportIntervalRequest): Promise<void> => {
  await httpPatch_New(`api/reader/${request.readerId}/report-interval`, request);
};

export const updateReaderContracts = async (readerId: string, contractIds: string[]): Promise<Reader> => {
  return await httpPut_New<Reader>(`api/reader/${readerId}/contracts`, contractIds);
};

export const getReaderLogByImei = async (request: GetReaderRequest): Promise<PaginatedResult<ReaderLog>> => {
  return await httpGet_New<PaginatedResult<ReaderLog>>(`api/logs/reader`, request);
};

export const addReader = async (request: Reader): Promise<any> => {
  return await httpPost_New<any>(`api/reader`, request);
};

export const updateReader = async (request: Reader): Promise<Reader> => {
  return await httpPut_New<Reader>(`api/reader`, request);
};

export const deleteReader = async (id: string): Promise<void> => {
  await httpDelete_New(`api/reader/${id}`);
};

export const appendLabel = async (request: LabelRequest): Promise<Reader> => {
  return await httpPost_New<Reader>(`api/reader/${request.readerId}/label/${request.labelId}`, request.labelId);
};

export const deleteLabel = async (request: LabelRequest): Promise<void> => {
  await httpDelete_New(`api/reader/${request.readerId}/label/${request.labelId}`);
};
